import { defineMessages } from '@formatjs/intl'

export const messages = defineMessages({
    authError: {
        id: 'app.authError',
        defaultMessage: 'Authorization server error',
    },
    pageTitle: {
        id: 'not-found-page.pageTitle',
        defaultMessage: 'Page not found',
    },
    notFoundPageDefaultMessage: {
        id: 'not-found-page.notFoundPageDefaultMessage',
        defaultMessage: 'The page you are looking for does not exist.',
    },
    notifications: {
        id: 'app.notifications',
        defaultMessage: 'Notifications',
    },
    noNotifications: {
        id: 'app.noNotifications',
        defaultMessage: 'Empty Notifications',
    },
    markAllAsRead: {
        id: 'app.markAllAsRead',
        defaultMessage: 'mark all as read',
    },
    version: {
        id: 'app.version',
        defaultMessage: 'Version',
    },
    newUpdateIsAvailable: {
        id: 'app.newUpdateIsAvailable',
        defaultMessage: 'New update is available.',
    },
    clickHere: {
        id: 'app.clickHere',
        defaultMessage: 'Click here!',
    },
    menuMainMenu: {
        id: 'app.menuMainMenu',
        defaultMessage: 'Main Menu',
    },
    menuDashboard: {
        id: 'app.menuDashboard',
        defaultMessage: 'Dashboard',
    },
    menuDevices: {
        id: 'app.menuDevices',
        defaultMessage: 'Devices',
    },
    menuIntegrations: {
        id: 'app.menuIntegrations',
        defaultMessage: 'Integrations',
    },
    menuRemoteClients: {
        id: 'app.menuRemoteClients',
        defaultMessage: 'Remote clients',
    },
    menuPendingCommands: {
        id: 'app.menuPendingCommands',
        defaultMessage: 'Pending commands',
    },
    menuOthers: {
        id: 'app.menuOthers',
        defaultMessage: 'Others',
    },
    menuDeviceProvisioning: {
        id: 'app.menuDeviceProvisioning',
        defaultMessage: 'Device provisioning',
    },
    enrollmentGroups: {
        id: 'app.enrollmentGroups',
        defaultMessage: 'Enrollment groups',
    },
    provisioningRecords: {
        id: 'app.provisioningRecords',
        defaultMessage: 'Provisioning records',
    },
    menuLinkedHubs: {
        id: 'app.menuLinkedHubs',
        defaultMessage: 'Linked Hubs',
    },
    menuCertificates: {
        id: 'app.menuCertificates',
        defaultMessage: 'Certificates',
    },
    menuRegistrationRecords: {
        id: 'app.menuRegistrationRecords',
        defaultMessage: 'Registration records',
    },
    menuDeviceFirmwareUpdate: {
        id: 'app.menuDeviceFirmwareUpdate',
        defaultMessage: 'Device Firmware update',
    },
    menuDeviceLogs: {
        id: 'app.menuDeviceLogs',
        defaultMessage: 'Device logs',
    },
    menuApiTokens: {
        id: 'app.menuApiTokens',
        defaultMessage: 'API tokens',
    },
    menuSchemaHub: {
        id: 'app.menuSchemaHub',
        defaultMessage: 'Schema Hub',
    },
    menuSupport: {
        id: 'app.menuSupport',
        defaultMessage: 'Support',
    },
    menuDocs: {
        id: 'app.menuDocs',
        defaultMessage: 'Docs',
    },
    menuChatRoom: {
        id: 'app.menuChatRoom',
        defaultMessage: 'Chat room',
    },
    menuConfiguration: {
        id: 'app.menuConfiguration',
        defaultMessage: 'Configuration',
    },
    menuSnippetService: {
        id: 'app.menuSnippetService',
        defaultMessage: 'Snippet Service',
    },
    menuConditions: {
        id: 'app.menuConditions',
        defaultMessage: 'Conditions',
    },
    menuConfigurations: {
        id: 'app.menuConfigurations',
        defaultMessage: 'Configurations',
    },
    menuAppliedConfigurations: {
        id: 'app.menuAppliedConfigurations',
        defaultMessage: 'Applied Configurations',
    },
})
